import { render, staticRenderFns } from "./SingleStore.vue?vue&type=template&id=239a64b4&"
import script from "./SingleStore.vue?vue&type=script&lang=js&"
export * from "./SingleStore.vue?vue&type=script&lang=js&"
import style0 from "./SingleStore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports